import { useEffect, useState } from "react";
import { messaging, getToken } from "./firebaseConfigWeb";

const useFCMToken = () => {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const requestPermission = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          const fcmToken = await getToken(messaging, {
            vapidKey: "BD7RaQYi0EvYfOW4TgCdNOjRgpqtsGP-FuLhrnUcvRw8VpO8c_dkFtOXml7_gEA2DkmW2MjZdW-WOdpV9K08vyk",
          });
          setToken(fcmToken);
          console.log("FCM Token:", fcmToken);
        } else {
          console.warn("Permission denied for notifications.");
        }
      } catch (error) {
        console.error("Error getting FCM token:", error);
      }
    };

    requestPermission();
  }, []);

  return token;
};

export default useFCMToken;
